import React from 'react';
import {
  translate as t,
} from 'admin-on-rest';
import {
  TextField,
} from 'material-ui';

const Youtube = ({ id, onChange, values }) => (
  <TextField
    className="block-field"
    floatingLabelText="youtube"
    onChange={(e) => onChange('url', id, e.target.value)}
    fullWidth
    defaultValue={values ? values.youtube : ''}
  />
);

export default t(Youtube);
